import features from "assets/images/virtualbanking_features.svg";
import limits from "assets/images/virtualbanking_limit.svg";

export const virtualbankingList = [
  {
    id: 0,
    title: "Features",
    content:
      "Use alrajhi@24seven Mobile Banking App or mobile / desktop browser to check your banking account balances, pay your bills, transfer funds, and more.",
    image: features,
    imageAlt: "Low Financing Rates",
  },
  {
    id: 1,
    title: "Limits of Transfers / Payments",
    content:
      "You are allowed to limit your transactions up to the maximum limit per day as follows:",
    image: limits,
    imageAlt: "Low Financing Rates",
    subcontent:
      "Note: These limits of Transfers / Payments are shared between alrajhi@24seven personal internet and mobile banking.",
  },
];
